import { identity } from 'lodash';

const alwaysSame = identity;

export default alwaysSame;
